import { SiteUrls } from '@tableau/shared-urls';
import { VizPortalWebClientRequester } from '@tableau/vizportal-webclient-api';
import React from 'react';
import {
  DataCatalogApolloClient,
  ReactTelemetryContext,
  VizClientDataCatalogProvider,
} from '../../../data-catalog-shared';
import { ViewDetailsByPathWrapper } from './ViewDetailsByPathWrapper';

export type EmbeddableVizClientLineagePanelProps = {
  readonly client: DataCatalogApolloClient;
  readonly siteUrlName: string;
  readonly queryString: string;
  readonly sheetPath: string;
  readonly testId: string;
  readonly onCloseRequested: () => void;
  readonly lastRefreshKey?: string;
  readonly vizPortalWebClientRequester: VizPortalWebClientRequester;
  readonly writableFieldDescriptionsEnabled: boolean;
  readonly siteLuid: string;
  readonly sessionId: string;
  readonly siteRole: string;
  readonly telemetryVizClientApiCallback?: (eventType: string, payload: Record<string, unknown>) => void;
};

export class EmbeddableVizClientLineagePanel extends React.Component<
  EmbeddableVizClientLineagePanelProps
> {
  public override render(): JSX.Element {
    return (
      <VizClientDataCatalogProvider
        telemetryVizClientApiCallback={this.props.telemetryVizClientApiCallback}
        client={this.props.client}
        siteUrls={
          new SiteUrls({
            siteUrlName: this.props.siteUrlName,
            queryString: this.props.queryString,
          })
        }
        siteLuid={this.props.siteLuid}
        featureFlags={{
          metricsDataCatalogEnabled: false, // feature flag is unused in VizClient
          writableFieldDescriptionsEnabled: this.props.writableFieldDescriptionsEnabled,
          fieldDescriptionInheritanceLineageEnabled: false, // Flag is not used in the lineage panel
          publishedConnectionsLineageEnabled: true,
          databasesInProjectsEnabled: false, // flag unused in vizclient
          lensLineageEnabled: false, // flag unused in vizclient
          relevantAssetsEnabled: true,
          mixedContentConnectToDialogEnabled: true,
          customSensitivityLabelsEnabled: false, // flag unused in vizclient for now
          searchAndFilterOnLineagePageEnabled: false, 
        }} >
        <ReactTelemetryContext.Provider
          value={{
            site_luid: this.props.siteLuid,
            session_id: this.props.sessionId,
            site_role: this.props.siteRole,
          }} >
          <ViewDetailsByPathWrapper
            viewPath={this.props.sheetPath}
            testId={this.props.testId}
            onCloseRequested={this.props.onCloseRequested}
            lastRefreshKey={this.props.lastRefreshKey}
            vizPortalWebClientRequester={this.props.vizPortalWebClientRequester}
          />
        </ReactTelemetryContext.Provider>
      </VizClientDataCatalogProvider>

    );
  }
}
